import { render, staticRenderFns } from "./FabricInventory.vue?vue&type=template&id=e198a8e8&scoped=true"
import script from "./FabricInventory.vue?vue&type=script&lang=js"
export * from "./FabricInventory.vue?vue&type=script&lang=js"
import style0 from "./FabricInventory.vue?vue&type=style&index=0&id=e198a8e8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e198a8e8",
  null
  
)

export default component.exports